export const getDataFromLs = (storeName: string) => {
  try {
    const serialState = localStorage.getItem(storeName);
    if (serialState === null) {
      return undefined;
    }

    try {
      return JSON.parse(serialState);
    } catch {
      return serialState;
    }
  } catch (err) {
    console.error(err);
  }
};

export const setDataToLs = (storeName: string, data: object | string) => {
  try {
    const serialState = typeof data === 'string' ? data : JSON.stringify(data);
    localStorage.setItem(storeName, serialState);
  } catch (err) {
    console.error(err);
  }
};

export const removeDataFromLs = (storeName: string) => {
  try {
    localStorage.removeItem(storeName);
  } catch (err) {
    console.error(err);
  }
};
